





































import {Component, Vue, Watch} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import ProductView from '@/components/ProductView.vue';
import {ISupplier} from '@/models/ISupplier';
import {getListSuppliers} from '@/services/SupplierService';
import RemoveSupplierBtn from '@/screens/dashboard/supplier/RemoveSupplierBtn.vue';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    ProductView,
    RemoveSupplierBtn
  }
})
export default class SuppliersTable extends Vue {
  loading: boolean = true;
  suppliers: ISupplier[] = [];
  headers: DataTableHeader[] = [
    {text: 'Name', value: 'name'},
    {text: 'Email', value: 'email'},
    {text: 'Google Sheet', value: 'gg_spread_sheet_id'},
    {text: 'Products', value: ''},
    {text: 'Actions', value: ''},
  ];

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.suppliers = [];
      this.suppliers = await getListSuppliers(this.organizationId, this.shopId);
    } finally {
      this.loading = false;
    }
  }

  goToSupplierDetailScreen(supplierId: number) {
    this.$router.push({name: 'dashboard.suppliers.detail', params: {supplierId: supplierId.toString()}});
  }
}
